import { useCallback, useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { AirdropType } from "../../../type";
import { AirdropFilterEnum } from "../../../type/enum";
import { getAllAirdop } from "../../../api/apiAirdrop";
import { Card, Skeleton } from "antd";
import AirdropGridCard from "../../airdrop/components/AirdropGridCard";

const PER_PAGE = 5;

const EventGoing = () => {
  const [airdrops, setAirdrops] = useState<AirdropType[]>([]);
  const [loading, setLoading] = useState(false);

  const handleGetAirdrops = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getAllAirdop(
        1,
        PER_PAGE,
        AirdropFilterEnum.AVAILABLE,
        ""
      );
      setAirdrops(response.data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    AOS.init({ duration: 800, once: false });
  }, []);

  useEffect(() => {
    handleGetAirdrops();
  }, [handleGetAirdrops]);

  return (
    <div className="py-8 md:py-16">
      <div className="container">
        <div className="wrap-going">
          <div
            className="font-Azonix text-[28px] sm:text-[45px] lg:text-[53px] leading-[1.3] text-text-secondary"
            data-aos="fade-up"
          >
            Ongoing Airdrops
          </div>
          {!loading ? (
            airdrops.length === 0 ? (
              <div className="col-span-12 flex flex-col w-full">
                <div className="h-[400px] bg-white flex items-center justify-center">
                  <img className="img-1" src="/images/nodata.png" alt="" />
                </div>
                <div className="w-full h-auto">
                  <img
                    src="/images/line-bot.png"
                    alt=""
                    className="w-full h-auto object-contain hidden lg:block"
                  />
                  <img
                    src="/images/line-open.png"
                    alt=""
                    className="w-full h-auto object-contain block lg:hidden"
                  />
                </div>
              </div>
            ) : (
              <div
                className={`mt-6 flex flex-wrap ${airdrops.length === 1 ? "justify-center" : ""}`}
              >
                {airdrops.map((airdrop) => (
                  <div className="w-full sm:w-1/2 lg:w-1/3 py-[10px] px-[10px]">
                    <AirdropGridCard
                      key={airdrop.id}
                      airdrop={airdrop}
                      isShowbutton={false}
                    />
                  </div>
                ))}
              </div>
            )
          ) : (
            <div className="mt-8 flex justify-center">
              <Card
                hoverable
                className="w-full sm:w-1/2 lg:w-1/3 min-h-[400px] max-h-[510px]"
              >
                <Skeleton active />
              </Card>
            </div>
          )}
          <div className="mt-5 flex justify-center">
            <a
              href="/airdrop"
              className="main-button w-200 text-center"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              VIEW ALL
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventGoing;
